import React, { useState, useEffect } from 'react';
import Card from '../../components/common/Card/Card';
import LoadingSpinner from '../../components/common/LoadingSpinner/LoadingSpinner';
import { getMyPocOwnerProjects } from '../../services/pocOwnerService';
import styles from './PocOwnerDashboard.module.css';

const PocOwnerDashboard = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        setProjects(await getMyPocOwnerProjects());
      } catch (error) {
        console.error('Error fetching POC owner projects:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, []);

  if (loading) {
    return (
      <div className={styles.loading}>
        <LoadingSpinner size="large" message="Loading dashboard..." />
      </div>
    );
  }

  const inProgress = projects.filter((p) => p.status === 'in_progress').length;
  const completed = projects.filter((p) => p.status === 'completed').length;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>Dashboard</h1>
      </div>

      <div className={styles.statsRow}>
        <Card className={styles.statCard}>
          <div className={styles.statContent}>
            <span className={styles.statValue}>{projects.length}</span>
            <span className={styles.statLabel}>Projects I'm POC For</span>
          </div>
        </Card>
        <Card className={styles.statCard}>
          <div className={styles.statContent}>
            <span className={styles.statValue}>{inProgress}</span>
            <span className={styles.statLabel}>In Progress</span>
          </div>
        </Card>
        <Card className={styles.statCard}>
          <div className={styles.statContent}>
            <span className={styles.statValue}>{completed}</span>
            <span className={styles.statLabel}>Completed</span>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default PocOwnerDashboard;
